import { editableEventStatusOptions } from '@/data/options';
import type { EventStatus } from '@/types/domain';
import { cn } from '@/utils/cn';
import { EventStatusBadge } from '@/components/shared/EventStatusBadge';

interface EventStatusPickerProps {
  value: EventStatus;
  disabled?: boolean;
  onChange: (status: EventStatus) => void;
}

export function EventStatusPicker({ value, disabled = false, onChange }: EventStatusPickerProps): JSX.Element {
  return (
    <div className={cn('event-status-picker', disabled && 'event-status-picker--disabled')} role="radiogroup" aria-label="Mass status">
      {editableEventStatusOptions.map((status) => {
        const isActive = value === status;

        return (
          <button
            key={status}
            type="button"
            role="radio"
            aria-checked={isActive}
            className={cn('event-status-picker__option', isActive && 'event-status-picker__option--active')}
            onClick={() => onChange(status)}
            disabled={disabled}
          >
            <EventStatusBadge status={status} size="sm" />
          </button>
        );
      })}
    </div>
  );
}
